<template>
    <div style="padding: 0 24px;">
        <div class="uploader">
            <span class="pro-title">图片：</span>
            <img :src="src" alt="" width="100px" style="width: 100px; height: 100px;" v-if="isShow" @click="update" class="cursor">
            <div class="add" @click="update" v-else>
                <span>+</span>
            </div>
            <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="fileChanged" ref="file" multiple="multiple">
        </div>
        <ul class="info-ul">
            <li class="info-li" v-for="item in userInfo" :key="item.id">
                <span class="pro-title">{{item.name}}：</span>
                <el-input v-model="item.value" size="small" placeholder="请输入"></el-input>
                <el-checkbox v-model="item.state" class="li-checkbox"></el-checkbox>
            </li>
            <li class="info-li info-add"><span @click="infoAdd">+</span></li>
        </ul>
        <ul class="pdesc-ul">
            <li class="pdesc-li" v-for="item in descInfo" :key="item.id">
                <span class="pro-title">{{item.name}}</span>
                <el-checkbox v-model="item.state" class="li-checkbox"></el-checkbox>
                <el-input type="textarea" :rows="3" :maxlength="500" placeholder="500字以内" v-model="item.value"></el-input>
            </li>
            <li class="pdesc-li pdesc-add" @click="descAdd"><span>+</span></li>
        </ul>
        <div style="text-align:center;margin-top: 40px;">
            <el-button @click.native="cancel" >返回</el-button>
            <el-button type="primary" @click.native="submit" v-loading="submitLoading">提交</el-button>
        </div>
    </div>
</template>

<script>
    import Dialog from '@/assets/js/dialog'
    import addUserInfoDialog from './addUserInfoDialog'
    import addDescInfoDialog from './addDescInfoDialog'
    import { imgFormData } from '@/api/api';
    import { addOrUpdateUserImgInfo } from '@/api/url';
    import {postFormData} from "../../../api/api";
    import {bindingUserImgInfo} from "../../../api/url";

    export default {
        props: {
            value: Object
        },
        data() {
            return {
                infoImgForm: this.value.infoImgForm,
                userForm: this.value.userForm,
                idx: this.value.idx,
                files: null,
                isShow: false,
                src: '',
                userInfo: [],
                userInfoDefault: [
                    {name: "姓名", state: true, value: ""},
                    {name: "性别", state: true, value: ""},
                    {name: "婚否", state: true, value: ""},
                    {name: "出生", state: true, value: ""},
                    {name: "学历", state: true, value: ""},
                    {name: "身高", state: true, value: ""},
                    {name: "职业", state: true, value: ""},
                    {name: "体重", state: true, value: ""},
                    {name: "月薪", state: true, value: ""},
                    {name: "房车", state: true, value: ""}
                ],
                descInfo: [],
                descInfoDefault: [
                    {name: "性格特点", state: true, value: ""},
                    {name: "择偶要求", state: true, value: ""},
                    {name: "来一段有诚意的自我介绍", state: true, value: ""},
                    {name: "想对ta说的话", state: true, value: ""}
                ],
                submitLoading: false,
                // 学历
                educationArray: ['初中', '中专/职高/技校', '高中', '大专', '本科', '硕士', '博士'],
            }
        },
        methods: {
            cancel() {
                this.$emit('close');
            },

            //更改或添加
            update() {
                this.$refs.file.click();
            },

            //选取图片
            fileChanged(e) {
                if(e.target.files[0]) {
                    this.files = e.target.files[0];
                    var windowURL = window.URL || window.webkitURL;
                    this.src = windowURL.createObjectURL(this.files);
                    this.isShow = true;
                }
            },

            // 添加user_info
            infoAdd() {
                Dialog.open({
                    title: '创建信息',
                    component: addUserInfoDialog,
                    data: {
                        width: '500px'
                    },
                    confirm: (result) => {
                        this.userInfo.push(result)
                    }
                })
            },

            // 添加内容
            descAdd() {
                Dialog.open({
                    title: '创建内容',
                    component: addDescInfoDialog,
                    data: {
                        width: '500px'
                    },
                    confirm: (result) => {
                        this.descInfo.push(result)
                    }
                })
            },

            // 提交
            submit() {
                let obj = {
                    name: '',
                    sex: '',
                    birthday: '',
                    height: '',
                    address: ''
                }
                if(!this.isShow) {
                    this.$message({
                        showClose: true,
                        duration: 1000,
                        message: '请选择图片',
                        type: 'warning'
                    })
                    return;
                }
                for(let item of this.userInfo) {
                    if(item.state && !item.value) {
                        this.$message({
                            showClose: true,
                            duration: 1000,
                            message: '所有信息不能为空',
                            type: 'warning'
                        })
                        return;
                    }
                    if(item.name == '姓名') {
                        obj.name = item.value;
                    }
                    if(item.name == '性别') {
                        if(item.value.replace(/\s*/g,"") == '男' || item.value.replace(/\s*/g,"") == '女') {
                            obj.sex = item.value.replace(/\s*/g,"") == '男' ? 1 : item.value.replace(/\s*/g,"") == '女' ? 2 : '';
                        } else {
                            this.$message({
                                showClose: true,
                                duration: 1000,
                                message: '性别信息填写不正确',
                                type: 'warning'
                            })
                            return;
                        }
                    }
                    if(item.name == '出生') {
                        obj.birthday = item.value;
                    }
                    if(item.name == '身高') {
                        obj.height = item.value;
                    }
                }
                for(let item of this.descInfo) {
                    if(item.state && !item.value) {
                        this.$message({
                            showClose: true,
                            duration: 1000,
                            message: '所有内容不能为空',
                            type: 'warning'
                        })
                        return;
                    }
                }
                let param = new FormData();
                param.append('id', this.infoImgForm.id);
                if ( this.idx == -2 ) {
                    param.append('userId', this.userForm.userId);
                }else {
                    param.append('userId', this.infoImgForm.userId);
                }
                param.append('userInfo', JSON.stringify(this.userInfo));
                param.append('descInfo', JSON.stringify(this.descInfo));
                param.append('name', obj.name);
                param.append('sex', obj.sex);
                if(this.files) {
                    param.append('file', this.files);
                }
                this.submitLoading = true;
                imgFormData(addOrUpdateUserImgInfo, param).then((data) => {
                    if(data.code == 200) {
                        this.$message({
                            showClose: true,
                            duration: 1000,
                            message: data.msg,
                            type: 'success'
                        })
                        this.$emit('confirm')
                    } else {
                        this.$message({
                            showClose: true,
                            duration: 1000,
                            message: data.msg,
                            type: 'warning'
                        })
                    }
                    this.submitLoading = false;
                })
                    .catch(() => {
                        this.submitLoading = false;
                    })
            },

            // relationUser() {
            //     let param = {
            //         id: this.infoImgForm.id,
            //         userId: this.userForm.userId
            //     }
            //     this.relationLoading = true;
            //     postFormData(bindingUserImgInfo, param).then((data) => {
            //         if(data.code == 200) {
            //             this.$message({
            //                 showClose: true,
            //                 duration: 1000,
            //                 message: data.msg,
            //                 type: 'success'
            //             })
            //             this.$emit('confirm', this.userForm)
            //         } else {
            //             this.$message({
            //                 showClose: true,
            //                 duration: 1000,
            //                 message: data.msg,
            //                 type: 'warning'
            //             })
            //         }
            //         this.relationLoading = false;
            //     })
            //         .catch(() => {
            //             this.relationLoading = false;
            //         })
            // }

        },
        mounted() {
            //初始化
            if(this.idx > -1) {
                this.userInfo = JSON.parse(this.value.infoImgForm.userInfo);
                this.descInfo = JSON.parse(this.value.infoImgForm.descInfo);
                this.src = this.value.infoImgForm.avatarSmall;
                if(this.src){
                    this.isShow = true;
                }
            } else if (this.idx === -1) {
                this.userInfo = this.userInfoDefault;
                this.descInfo = this.descInfoDefault;
            } else if (this.idx == -2) {
                this.userInfo = [
                    {name: "姓名", state: true, value: this.userForm.userName},
                    {name: "性别", state: true, value: this.userForm.sex == 1 ? '男' : this.userForm.sex == 2 ? '女' : ''},
                    {name: "婚否", state: true, value: this.userForm.marryState == 1 ? '未婚' : this.userForm.marryState == 2 ? '离异' : this.userForm.marryState == 3 ? '丧偶' : ''},
                    {name: "出生", state: true, value: this.userForm.sysBirthday},
                    {name: "学历", state: true, value: this.userForm.education ? this.educationArray[this.userForm.education - 1] : ''},
                    {name: "身高", state: true, value: this.userForm.height + 'cm'},
                    {name: "职业", state: true, value: this.userForm.position},
                    {name: "体重", state: true, value: this.userForm.weight + 'kg'},
                    {name: "月薪", state: true, value: this.userForm.salaryMin + '-' + this.userForm.salaryMax + 'k'},
                    {name: "房车", state: true, value: this.userForm.houseAndCar}
                ]
                this.descInfo = [
                    {name: "性格特点", state: true, value: ""},
                    {name: "择偶要求", state: true, value: ""},
                    {name: "来一段有诚意的自我介绍", state: true, value: this.userForm.pdesc},
                    {name: "想对ta说的话", state: true, value: this.userForm.sweetWords}
                ]
            }
        }
    }
</script>

<style scoped>
    ul {
        margin: 0;
        padding: 0;
    }
    .pro-title {
        margin-right: 10px;
        flex-shrink: 0;
    }

    .info-ul::after {
        content: '';
        clear: both;
        display: block;
        height: 0;
        visibility: hidden;
    }
    .info-li {
        width: 46%;
        display: flex;
        align-items: center;
        margin-top: 10px;
        float: left;
        list-style: none;
    }
    .info-li:nth-child(2n+1) {
        margin-right: 8%;
    }
    .li-checkbox {
        margin: 0 10px;
    }
    .info-add {
        /* border: 1px dashed #aaa;
        height: 32px; */
        text-align: center;
        justify-content: center;
        padding: 0 30px 0 50px;
        box-sizing: border-box;
    }
    .info-add>span {
        border: 1px dashed #ececec;
        height: 32px;
        width: 100%;
        line-height: 32px;
        cursor: pointer;
    }


    .pdesc-ul {
        margin-top: 40px;
    }
    .pdesc-li {
        margin-top: 20px;
        list-style: none;
    }
    .pdesc-add {
        text-align: center;
        justify-content: center;
        border: 1px dashed #ececec;
        height: 50px;
        line-height: 50px;
        font-size: 20px;
        cursor: pointer;
    }


    .uploader {
        overflow: hidden;
        display: flex;
        align-items: center;
    }

    .uploader .add {
        width: 100px;
        height: 100px;
        text-align: center;
        line-height: 100px;
        border: 1px dashed #ececec;
        font-size: 30px;
        cursor: pointer;
        margin: 0;
    }

    .uploader img{
        display: block;
    }

    .uploader > input[type="file"] {
        display: none;
    }

</style>
